import { memo, useCallback } from 'react';
import { View, ViewStyle, Keyboard } from 'react-native';
import { useStyle } from '@betty/moonlight';

import { ScreenProps } from './Screen.types';

function Screen({
  paddingBottom = 'space-0',
  paddingHorizontal = 'space-600',
  backgroundColor = 'screenBackground',
  ...props
}: ScreenProps) {
  const style = useStyle<ViewStyle>({
    flex: 1,
    paddingBottom,
    paddingHorizontal,
    backgroundColor,
  });

  const onStartShouldSetResponder = useCallback(() => {
    Keyboard.dismiss();

    return false;
  }, []);

  return (
    <View
      style={style}
      onStartShouldSetResponder={onStartShouldSetResponder}
      {...props}
    />
  );
}

export default memo(Screen);
